import { LayoutComponent } from './layout/layout/layout.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PagesLayoutComponent } from './layout/pages-layout/pages-layout.component';
import { DashboardComponent } from './dashboard/dashboard.component';

import { ClientsComponent } from './layout/pages-layout/nomenclatoare/clients/clients.component';
import { GalleryComponent } from './layout/pages-layout/nomenclatoare/gallery/gallery.component';
import { AplicationComponent } from './layout/pages-layout/nomenclatoare/aplication/aplication.component';
import { SettingsSidenavComponent } from './layout/pages-layout/nomenclatoare/settings-sidenav/settings-sidenav.component';
import { AdminSettingsComponent } from './layout/pages-layout/nomenclatoare/administration/admin-settings/admin-settings.component';
import { RequestsComponent } from './layout/pages-layout/nomenclatoare/cetatean/requests/requests.component';
import { PreEnrolledAccountsComponent } from './layout/pages-layout/nomenclatoare/cetatean/pre-enrolled-accounts/pre-enrolled-accounts.component';
import { CetateanAccountsComponent } from './layout/pages-layout/nomenclatoare/cetatean/cetatean-accounts/cetatean-accounts.component';
import { TokenGuard } from './guards/token.guard';
import { LogoutComponent } from './logout/logout.component';
import { CerereSabloaneComponent } from './layout/pages-layout/nomenclatoare/settings-sidenav/cerere-sabloane/cerere-sabloane.component';
import { BeneficiariComponent } from './layout/pages-layout/nomenclatoare/cetatean/beneficiari/beneficiari.component';
import { PermissionsGuard } from './guards/permissions.guard';
import { RecenziiComponent } from './layout/pages-layout/nomenclatoare/cetatean/recenzii/recenzii.component';
import { DocumenteCetateanComponent } from './layout/pages-layout/nomenclatoare/cetatean/documente-cetatean/documente-cetatean.component';
import { ConfirmareDocumenteComponent } from './layout/pages-layout/nomenclatoare/cetatean/confirmare-documente/confirmare-documente.component';
import { RapoarteComponent } from './layout/pages-layout/nomenclatoare/cetatean/rapoarte/rapoarte.component';
import { BorderouComponent } from './layout/pages-layout/nomenclatoare/cetatean/borderou/borderou.component';
import { InstitutiiSettingsComponent } from './layout/pages-layout/nomenclatoare/institutii/institutii-settings/institutii-settings.component';
import { DocumentePubliceComponent } from './layout/pages-layout/nomenclatoare/institutii/documente-publice/documente-publice.component';
import { OperatoriInstitutiiComponent } from './layout/pages-layout/nomenclatoare/institutii/operatori-institutii/operatori-institutii.component';
import { BulevartComponent } from './layout/pages-layout/nomenclatoare/bulevart/bulevart-galerie/bulevart.component';
import { BulevartSettingsComponent } from './layout/pages-layout/nomenclatoare/bulevart/bulevart-settings/bulevart-settings.component';
import { GhiseulUnicSettingsComponent } from './layout/pages-layout/nomenclatoare/ghiseul-unic/ghiseul-unic-settings/ghiseul-unic-settings.component';
import { CereriComponent as GhiseulUnicCereriComponent } from './layout/pages-layout/nomenclatoare/ghiseul-unic/cereri/cereri.component';
import { ProgramariComponent as GhiseulUnicProgramariComponent } from './layout/pages-layout/nomenclatoare/ghiseul-unic/programari/programari.component';
import { SidenavGuard } from './guards/sidenav.guard';
import { ProgramariViewComponent } from './layout/pages-layout/nomenclatoare/ghiseul-unic/programari-view/programari-view.component';
import { NotificariComponent } from './layout/pages-layout/nomenclatoare/ghiseul-unic/notificari/notificari.component';
import { BorderouriAutomateComponent } from './layout/pages-layout/nomenclatoare/ghiseul-unic/borderouri-automate/borderouri-automate.component';
import { DashboardProgramariComponent } from './layout/pages-layout/nomenclatoare/ghiseul-unic/dashboard-programari/dashboard-programari.component';

const routes: Routes = [
    {
        path: 'pages',
        redirectTo: '',
        pathMatch: 'full',
    },
    {
        path: 'pages',
        component: PagesLayoutComponent,
    },
    {
        path: '',
        component: LayoutComponent,
        canActivate: [TokenGuard, PermissionsGuard, SidenavGuard],

        children: [
            {
                path: '',
                component: DashboardComponent,
            },
            {
                path: 'settings',
                component: SettingsSidenavComponent,
            },
            {
                path: 'aplicatii',
                component: AplicationComponent,
            },
            {
                path: 'galerie',
                component: GalleryComponent,
            },
            {
                path: 'clienti',
                component: ClientsComponent,
            },
            {
                path: 'ghiseul-unic-dashboard',
                component: DashboardProgramariComponent,
            },
            {
                path: 'ghiseul-unic-cereri',
                component: GhiseulUnicCereriComponent,
            },
            {
                path: 'ghiseul-unic-programari',
                component: GhiseulUnicProgramariComponent,
            },
            {
                path: 'ghiseul-unic-notificari',
                component: NotificariComponent,
            },
            {
                path: 'ghiseul-unic-borderouri-automate',
                component: BorderouriAutomateComponent,
            },
            {
                path: 'ghiseul-unic-programari-view',
                component: ProgramariViewComponent,
            },
            {
                path: 'ghiseul-unic-settings',
                component: GhiseulUnicSettingsComponent,
            },
            {
                path: 'admin-settings',
                component: AdminSettingsComponent,
            },
            {
                path: 'requests',
                component: RequestsComponent,
            },
            {
                path: 'conturi-preinrolate',
                component: PreEnrolledAccountsComponent,
            },
            {
                path: 'conturi-cetatean',
                component: CetateanAccountsComponent,
            },
            {
                path: 'beneficiari',
                component: BeneficiariComponent,
            },
            {
                path: 'sabloane-requests',
                component: CerereSabloaneComponent,
            },
            {
                path: 'recenzii',
                component: RecenziiComponent,
            },
            {
                path: 'documente-cetatean',
                component: DocumenteCetateanComponent,
            },
            {
                path: 'confirmare-documente',
                component: ConfirmareDocumenteComponent,
            },
            {
                path: 'rapoarte',
                component: RapoarteComponent,
            },
            {
                path: 'borderou',
                component: BorderouComponent,
            },
            {
                path: 'documente-publice',
                component: DocumentePubliceComponent,
            },
            {
                path: 'institutii-settings',
                component: InstitutiiSettingsComponent,
            },
            {
                path: 'operatori-institutii',
                component: OperatoriInstitutiiComponent,
            },
            {
                path: 'bulevart-gallery',
                component: BulevartComponent,
            },
            {
                path: 'bulevart-settings',
                component: BulevartSettingsComponent,
            },
        ],
    },
    {
        path: 'logout',
        component: LogoutComponent
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled',
        useHash: true
    })],
    exports: [RouterModule],
})
export class AppRoutingModule { }
